var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKpi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1255_4062)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1526 27.8308V22.0886H15.7932C16.6993 22.0886 17.4338 22.8231 17.4338 23.7292C17.4338 24.6354 16.6993 25.3699 15.7932 25.3699H14.1526",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.22876 27.8308V21.2683",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.22876 24.5496H8.86938C9.7755 24.5496 10.51 23.8151 10.51 22.9089V21.2683",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.22876 24.5496H8.86938C9.7755 24.5496 10.51 25.2841 10.51 26.1902V27.8308",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7712 21.2683V27.8308",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 18.7681H28",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.37793 11.2332C6.28402 11.2332 7.01855 10.4986 7.01855 9.59253C7.01855 8.68644 6.28402 7.9519 5.37793 7.9519C4.47184 7.9519 3.7373 8.68644 3.7373 9.59253C3.7373 10.4986 4.47184 11.2332 5.37793 11.2332Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.126 6.49695C12.0321 6.49695 12.7666 5.76242 12.7666 4.85632C12.7666 3.95023 12.0321 3.2157 11.126 3.2157C10.2199 3.2157 9.48535 3.95023 9.48535 4.85632C9.48535 5.76242 10.2199 6.49695 11.126 6.49695Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8738 9.71375C17.7799 9.71375 18.5144 8.97921 18.5144 8.07312C18.5144 7.16703 17.7799 6.4325 16.8738 6.4325C15.9677 6.4325 15.2332 7.16703 15.2332 8.07312C15.2332 8.97921 15.9677 9.71375 16.8738 9.71375Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6218 4.27087C23.5279 4.27087 24.2625 3.53634 24.2625 2.63025C24.2625 1.72416 23.5279 0.989624 22.6218 0.989624C21.7157 0.989624 20.9812 1.72416 20.9812 2.63025C20.9812 3.53634 21.7157 4.27087 22.6218 4.27087Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.86863 18.7681V15.406H3.7373V18.7681",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1313 18.7681V15.406H14V18.7681",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9999 18.7681V13.5343H8.86865V18.7681",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2627 18.7681V12.5699H19.1313V18.7681",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0649 6.94534L21.431 3.75793",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4424 7.2719L12.5576 5.65747",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.64429 8.54921L9.85986 5.89966",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1255_4062"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKpi);
export default __webpack_public_path__ + "static/media/kpi.3fe16f2b8f17111f3d44c320cf2cec1c.svg";
export { ForwardRef as ReactComponent };